import React, {useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';

import {hooks} from '../../hooks';
import {items} from '../../items';
import type {FeeCatType} from '../../types';
import {Routes} from '../../routes';
import {components} from '../../components';

import type {FeeKindDetailsType} from '../../types';
import {svg} from '../../assets/svg';

export const FeeDetails: React.FC = () => {
  const dispatch = hooks.useDispatch();
  const navigate = hooks.useNavigate();

  // const {menuLoading, menu} = hooks.useGetMenu();
  const {feeCatLoading, feeCat} = hooks.useGetFeeCat();
  const {feeKindLoading, feeKind} = hooks.useGetFeeKindDetails();
  // const {dishesLoading, dishes} = hooks.useGetDishes();

  const location = hooks.useLocation();
  const feeCatName = location.state?.feeCat ?? feeCat[0]?.name ?? '';

  const [opacity, setOpacity] = useState<number>(0);
  const [selectedCategory, setSelectedCategory] = useState<string>(feeCatName);

  const filteredFeeKind = Array.isArray(feeKind)
  ? feeKind.filter((kind: FeeKindDetailsType) =>
      kind.name.toLowerCase().includes(selectedCategory.toLowerCase())
    )
  : [];

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderSearch = (): JSX.Element | null => {
    if (
      feeCatLoading ||
      feeKindLoading ||
      feeCat.length === 0 ||
      feeKind.length === 0
    ) {
      return null;
    }

    return (
      <section
        className='row-center container'
        style={{gap: 5, marginTop: 10}}
      >
        <button
          style={{
            height: 50,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 5,
            gap: 14,
            flex: 1,
            backgroundColor: 'var(--white-color)',
            borderRadius: 10,
          }}
          onClick={() => navigate(Routes.Search)}
        >
          <svg.SearchSvg />
          <span className='t16'>Search ...</span>
        </button>
        <button
          style={{
            width: 50,
            height: 50,
            backgroundColor: 'var(--white-color)',
            borderRadius: 10,
          }}
          className='center'
          onClick={() => navigate(Routes.Filter)}
        >
          <svg.FilterSvg />
        </button>
      </section>
    );
  };

  const renderCategories = (): JSX.Element | null => {
    if (
      feeCatLoading ||
      feeKindLoading ||
      feeCat.length === 0 ||
      feeKind.length === 0
    ) {
      return null;
    }

    return (
      <section style={{width: '100%', marginTop: 14, paddingBottom: 20}}>
        <Swiper
          spaceBetween={8}
          slidesPerView={'auto'}
          pagination={{clickable: true}}
          navigation={true}
          mousewheel={true}
        >
          {feeCat.map((category: FeeCatType, index, array) => {
            const isLast = index === array.length - 1;

            return (
              <SwiperSlide
                key={category.id}
                style={{
                  width: 'auto',
                  marginLeft: index === 0 ? 20 : 0,
                  marginRight: isLast ? 20 : 0,
                }}
                onClick={() => setSelectedCategory(category.name)}
              >
                <div
                  style={{
                    padding: '10px 20px',
                    borderRadius: 10,
                    border: '1px solid red',
                    borderColor:
                      selectedCategory === category.name
                        ? 'var(--main-turquoise)'
                        : 'var(--white-color)',
                    backgroundColor: 'var(--white-color)',
                  }}
                >
                  <h5
                    style={{
                      textTransform: 'capitalize',
                      color:
                        selectedCategory === category.name
                          ? 'var(--main-turquoise)'
                          : 'var(--main-color)',
                    }}
                  >
                    {category.name}
                  </h5>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </section>
    );
  };

  const renderContent = (): JSX.Element | null => {
    if (
      feeCatLoading ||
      feeKindLoading ||
      feeCat.length === 0 ||
      feeKind.length === 0
    ) {
      return null;
    }

    return (
      <main className='scrollable container'>
        <ul style={{paddingBottom: 20}}>
          {filteredFeeKind.map(
            (kind: FeeKindDetailsType, index: number, array: FeeKindDetailsType[]) => {
              const isLast = index === array.length - 1;

              return (
                <items.FeeKindDetailsItem
                  feeKind={kind}
                  index={index}
                  key={kind.id}
                  isLast={isLast}
                />
              );
            },
          )}
        </ul>
      </main>
    );
  };

  const renderLoader = (): JSX.Element | null => {
    if (
      feeCatLoading ||
      feeKindLoading ||
      feeCat.length === 0 ||
      feeKind.length === 0
    ) {
      return <components.Loader />;
    }
    return null;
  };

  const renderContentAll = (): JSX.Element | null => {
    return (
      <>
        {renderSearch()}
        {renderCategories()}
        {renderContent()}
        {renderLoader()}
      </>
    );
  }

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderContentAll()}
    </div>
  );
};
